import { PeopleCarousel } from "./PeopleCarousel";
import { PeopleList } from "./PeopleList";
import { PeopleMap } from "./PeopleMap";

type PeopleCompound = {
  List: typeof PeopleList;
  Map: typeof PeopleMap;
  Carousel: typeof PeopleCarousel;
};

export const People: PeopleCompound = {
  List: PeopleList,
  Map: PeopleMap,
  Carousel: PeopleCarousel,
};
